import styled from "styled-components";
import { useState } from 'react';
import { IoIosArrowDown as DownArrow } from "react-icons/io";
import { studentCardsData as cardsData } from "../targetContent";

// Desktop Card Styles
const DesktopCardContainer = styled.article`
  display: flex;
  width: 340px;
  padding-bottom: 40px;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  border-radius: 16px;
  position: relative;
  height: 300px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background-color: #fff;

  @media (max-width: 991px) {
    width: 100%;
    max-width: 360px;
  }
  
  @media (max-width: 640px) {
    display: none;
  }
`;

const DesktopHeaderImage = styled.img`
  width: 100%;
  height: 173px;
  aspect-ratio: 97/52;
  border-radius: 16px 16px 0 0;
  background-color: #f3f4f6;
  object-fit: cover;

  @media (max-width: 640px) {
    height: 160px;
  }
`;

const DesktopContentContainer = styled.section`
  display: flex;
  width: 310px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-top: 20px;
  
  @media (max-width: 991px) {
    width: calc(100% - 40px);
  }
`;

const DesktopTitleHeading = styled.h2`
  color: #141221;
  letter-spacing: -0.2px;
  margin: 0;
  font: 700 20px/140% Inter, sans-serif;

  @media (max-width: 991px) {
    font-size: 18px;
  }
`;

const DesktopDescriptionText = styled.p`
  flex: 1 0 0;
  color: #0a1d31;
  letter-spacing: -0.08px;
  margin: 0;
  font: 400 16px/160% Inter, sans-serif;

  @media (max-width: 991px) {
    font-size: 15px;
  }
`;

// Mobile Accordion Styles
const MobileCardContainer = styled.article`
  display: none;
  
  @media (max-width: 640px) {
    display: flex;
    width: 100%;
    padding: 0;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #fff;
    gap: 0;
  }
`;

const MobileAccordionButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  
  &:focus {
    outline: 2px solid #6A37E3;
    outline-offset: -2px;
  }
  
  &:focus:not(:focus-visible) {
    outline: none;
  }
  
  &:focus-visible {
    outline: 2px solid #6A37E3;
    outline-offset: -2px;
  }
`;

const MobileTitleHeading = styled.h2`
  color: #141221;
  letter-spacing: -0.2px;
  margin: 0;
  font: 700 16px/130% Inter, sans-serif;
  flex: 1;
`;

const MobileArrowIcon = styled(DownArrow)`
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
  transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  flex-shrink: 0;
  margin-left: 12px;
  color: #141221;
`;

const MobileExpandableContent = styled.div`
  max-height: ${props => props.$isOpen ? '600px' : '0'};
  opacity: ${props => props.$isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.4s ease;
  padding: ${props => props.$isOpen ? '0 20px 20px 20px' : '0 20px'};
`;

const MobileImageWrapper = styled.div`
  width: 100%;
  margin-top: ${props => props.$isOpen ? '0' : '0'};
  transition: margin 0.3s ease;
`;

const MobileHeaderImage = styled.img`
  width: 100%;
  height: 160px;
  border-radius: 12px;
  background-color: #f3f4f6;
  object-fit: cover;
`;

const MobileDescriptionText = styled.p`
  color: #0a1d31;
  letter-spacing: -0.08px;
  margin: 12px 0 0 0;
  font: 400 14px/150% Inter, sans-serif;
`;

// Common Container Styles
const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F1EDFC;
  margin: 0 auto;
  font-family: Inter, sans-serif;
  padding: 50px;
  overflow-x: hidden;  
  
  @media (max-width: 1291px) {
    padding: 50px 16px;
  }
`;

const HeaderContainer1 = styled.header`
  align-self: center;
  width: 991px;
  max-width: 100%;
  font-weight: 700;
  text-align: center;
`;

const SectionTitle = styled.p`
  color: #1c1b1f;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const SectionTitle1 = styled.p`
  color: #1c1b1f;
  font: 500 16px Inter, sans-serif;
  margin-top: 10px;
  letter-spacing: -0.5%;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const SubtitleContainer = styled.div`
  display: flex;
  margin-top: 20px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  font-size: 48px;
  color: #0a0911;
  letter-spacing: -0.48px;
  line-height: 58px;
 
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 54px;
  }
`;

const MainHeading = styled.h1`
  margin: 0;
    font-size: 48px;
  
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 54px;
  }
  @media (max-width: 640px) {
    max-width: 100%;
    font-size: 32px;
    line-height: 43px;
  }
`;

const CardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 50px;
  justify-content: center;
  max-width: 1600px;
  @media (max-width: 1500px) {
    justify-content: center;
  }
  
  @media (max-width: 640px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

const CardWrapper = styled.div`

`;


// Desktop Card Component
function DesktopFeatureCard({ card }) {
  return (
    <DesktopCardContainer>
      <DesktopHeaderImage 
        src={card.image} 
        alt={card.altText}
      />
      <DesktopContentContainer>
        <DesktopTitleHeading>{card.title}</DesktopTitleHeading>
        <DesktopDescriptionText>{card.description}</DesktopDescriptionText>
      </DesktopContentContainer>
    </DesktopCardContainer>
  );
}

// Mobile Accordion Card Component
function MobileFeatureCard({ card, index }) {
  const [isOpen, setIsOpen] = useState(index === 0);
  const contentId = `accordion-content-${index}`;
  const buttonId = `accordion-button-${index}`;

  const toggleCard = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleCard();
    }
  };

  return (
    <MobileCardContainer>
      <MobileAccordionButton
        id={buttonId}
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={toggleCard}
        onKeyDown={handleKeyDown}
      >
        <MobileTitleHeading>{card.title}</MobileTitleHeading>
        <MobileArrowIcon 
          $isOpen={isOpen} 
          aria-hidden="true"
        />
      </MobileAccordionButton>
      
      <MobileExpandableContent 
        id={contentId}
        role="region"
        aria-labelledby={buttonId}
        $isOpen={isOpen}
      >
        <MobileImageWrapper $isOpen={isOpen}>
          <MobileHeaderImage 
            src={card.image} 
            alt={card.altText}
          />
        </MobileImageWrapper>
        <MobileDescriptionText>
          {card.description}
        </MobileDescriptionText>
      </MobileExpandableContent>
    </MobileCardContainer>
  );
}

function ConversationalAiCard() {
  return (
    <FeaturesContainer>
      <HeaderContainer1>
        <SectionTitle>Features Grid</SectionTitle>
        <SubtitleContainer>
          <MainHeading>
            Smarter Conversations, Deeper Insights, Better Outcomes 
          </MainHeading>
        </SubtitleContainer>
        <SectionTitle1>Campus Insights isn't just a tool-its your AI Partner</SectionTitle1>
      </HeaderContainer1>

      <CardsGrid>
        {cardsData.map((card, index) => (
          <CardWrapper key={index}>
            <DesktopFeatureCard card={card} />
            <MobileFeatureCard card={card} index={index} />
          </CardWrapper>
        ))}
      </CardsGrid>
    </FeaturesContainer>
  );
}

export default ConversationalAiCard;